import React, { useState } from "react";
import axios from "axios";

import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputRightAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  HStack,
  Stack,
  Radio,
  RadioGroup,
  Center,
  Checkbox,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

import { useToast } from "@chakra-ui/react";
import { useMediaQuery } from '@chakra-ui/react';

import { validatePercentage,validateInstituteName  } from './Validation';

const Form2 = (props) => {
  const [show, setShow] = React.useState(false);
  const [instituteID, setinstituteID] = useState("");
  const [instituteName, setinstituteName] = useState("");
  const [degree, setDegree] = useState("");
  const [branch, setBranch] = useState("");
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [aggregate, setAggregate] = useState();
  const [isLateral, setIsLateral] = useState(false);
  const handleClick = () => setShow(!show);

  const [isSmallerThan750] = useMediaQuery('(max-width: 750px)');

  //validations errors
const [percentageError, setPercentageError] = useState('');
const [instituteNameError, setInstituteNameError] = useState('');

const toast = useToast();

  const handleNext = () => {


    if(!instituteID || !instituteName ){
      toast({
        title: 'Validation Error',
        description: 'Please fill in all required fields.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (percentageError || instituteNameError) {
      toast({
        title: 'Validation Error',
        description: 'Please correct the errors in the form.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return; // Prevent submission if there are validation errors
    }

    const formData = {
      instituteID: instituteID,
      instituteName: instituteName,
      degree: degree,
      branch: branch,
      tenure: {
        start: start,
        end: end,
      },
      isLateral: isLateral,
    };

    axios
      .post("https://glb-api.onrender.com/student/form2", {formData:formData}, {withCredentials : true })
      .then((res) => {
        console.log("sent successfully" + JSON.stringify(formData));
      })
      .catch((err) => {
        console.log(err);
      });
    // props.onNext();
  };
  const handleBack = () => {
    // Handle form submission
    // ...
    // Call the OnBack callback from props to update the step state
    props.OnBack();
  };

  // validations
  const handlePercentageChange = (e) => {
    const value = e.target.value;
    setAggregate(value);

    // Validate percentage using the imported function
    const error = validatePercentage(value);
    setPercentageError(error);
  };
  const handleInstituteNameChange = (e) => {
    const value = e.target.value;
    setinstituteName(value);

    // Validate institute name using the imported function
    const error = validateInstituteName(value);
    setInstituteNameError(error);
  };


  return (
    <>
      <Box px="150px">
        <Heading
          w="100%"
          textAlign={"center"}

          fontSize="5xl"
          mb="4%"
        >
          Current / Recent Education
        </Heading>
        <Stack mt={"40px"}>
          <FormControl  size="sm" isRequired >
            <FormLabel htmlFor="options"  fontSize="md" >
              Choose an option
            </FormLabel>
          </FormControl>
          <RadioGroup defaultValue="1">
            <Stack>
              <Radio size={"sm"} value="1" style={{
        borderWidth: "2px",  // Add thicker border here
        borderColor: "black", // Change border color if needed
      }}>
                <Text fontSize={"md"}>
                  I am currently pursuing an education and have not recevied my
                  degree
                </Text>
              </Radio>
              <Radio size={"sm"} value="2" style={{
        borderWidth: "2px",  // Add thicker border here
        borderColor: "black", // Change border color if needed

      }}>
                <Text fontSize={"md"}>I have completed my education</Text>
              </Radio>
            </Stack>
          </RadioGroup>
        </Stack>

        <Flex mt={"40px"}  direction={isSmallerThan750 ? 'column' : 'row'}
          alignItems="center"
          justify="center"
          spacing={4}>
          <FormControl mr="5%" >
            <FormLabel



            >
              Program
            </FormLabel>
            <Select borderColor="transparent" boxShadow="md" placeholder="Select option">
              <option  value="option1">
                Option 1
              </option>
              <option  value="option2">
                Option 2
              </option>
              <option  value="option3">
                Option 3
              </option>
            </Select>
          </FormControl>

          <FormControl mr="5%" >
            <FormLabel


            >
              Major / Branch
            </FormLabel>
            <Select borderColor="transparent" boxShadow="md" placeholder="Select option">
              <option  value="option1">
                Option 1
              </option>
              <option  value="option2">
                Option 2
              </option>
              <option  value="option3">
                Option 3
              </option>
            </Select>
          </FormControl>
        </Flex>
        {/*
        <Center mt={'40px'}>
        <Flex width={"100%"} alignItems={"center"}>
        <FormControl width={'md'} size="sm">
            <FormLabel htmlFor="DOB" fontSize="4md" fontWeight={'thin'}>
              Batch
            </FormLabel>
            <Select size={"sm"} placeholder='Select option'>
  <option  fontSize="4md" value='option1'>Option 1</option>
  <option  fontSize="4md" value='option2'>Option 2</option>
  <option  fontSize="4md" value='option3'>Option 3</option>
</Select>
          </FormControl>
        </Flex>
        </Center> */}

        <Flex mt={"40px"} direction={{ base: "column", md: "row" }}>
  <FormControl mr={{ base: "0", md: "5%" }} mb={{ base: "5%", md: "0" }} size="sm">
    <FormLabel htmlFor="first-name" fontSize="4md" >
      Current Course Start Date
    </FormLabel>
    <Input


      borderColor="transparent"
      boxShadow="md"
      type="date"
      value={start}
      onChange={(e) => {
        setStart(e.target.value);
      }}
    />
  </FormControl>

  <FormControl mr={{ base: "0", md: "5%" }} mb={{ base: "5%", md: "0" }} size="sm">
    <FormLabel htmlFor="middle-name" fontSize="4md" >
      Current Course End Date
    </FormLabel>
    <Input
      borderColor="transparent"
      boxShadow="md"
      type="date"
      value={end}
      onChange={(e) => {
        setEnd(e.target.value);
      }}
    />
  </FormControl>
</Flex>

        <Flex mt={"40px"} width={"100%"} alignItems={"center"}>
          <FormControl width={"md"} size="sm" isRequired >
            <FormLabel htmlFor="DOB" fontSize="4md" >
              Institute Roll Number / University ID
            </FormLabel>
            <Input
              width="100%"
              id="Roll-Number"

              placeholder="Roll Number"
              borderColor="transparent"
              boxShadow="md"
              value={instituteID}
              onChange={(e) => {
                setinstituteID(e.target.value);
                console.log(instituteID);
              }}
            />

            <FormHelperText fontSize="sm">
              We'll never share your Id.
            </FormHelperText>
          </FormControl>
        </Flex>
        <Flex mt={"40px"} width={"100%"} alignItems={"center"}>
        <FormControl width={"md"} size="sm" isRequired isInvalid={!!instituteNameError}>
  <FormLabel htmlFor="DOB" fontSize="4md">
    Institute Name
  </FormLabel>
  <Input
    width="100%"
    id="Institute-name"
    placeholder="Institute Name"
    borderColor={!!instituteNameError ? 'red.300' : 'transparent'}
    boxShadow="md"
    value={instituteName}
    onChange={handleInstituteNameChange}
  />
  <FormErrorMessage color="red.500">
    {instituteNameError}
  </FormErrorMessage>
</FormControl>



        </Flex>

        {/* <Flex mt={'40px'} width={"100%"} alignItems={"center"}>
        <FormControl width={'md'} size="sm" >
            <FormLabel htmlFor="DOB" fontSize="4md" fontWeight={'thin'}>
            Current Semester
            </FormLabel>
            <Select size={"sm"} placeholder='Select option'>
  <option  fontSize="4md" value='option1'>Option 1</option>
  <option  fontSize="4md" value='option2'>Option 2</option>
  <option  fontSize="4md" value='option3'>Option 3</option>
</Select>

          </FormControl>

        </Flex> */}



<Stack mt={"40px"} mb={"40px"}>
          <FormControl  size="sm" isRequired isInvalid={!!percentageError}>
            <FormLabel fontSize="2md" fontWeight={"bold"}>
              Enter your Percentage
            </FormLabel>
            <HStack>
              <FormHelperText fontSize="sm">
                If your college uses CGPA or Grades, enter equivalent percentage
              </FormHelperText>
              <InputGroup>
                <Input
                  width={"100px"}
                  type="number"
                  borderColor={!!percentageError ? 'red.300' : 'transparent'}
                  boxShadow="md"
                  placeholder="%"
                  value={aggregate}
                  onChange={handlePercentageChange}
                />
              </InputGroup>
            </HStack>
            {percentageError && (
              <FormErrorMessage color="red.500">{percentageError}</FormErrorMessage>
            )}
          </FormControl>
        </Stack>

        {/* <Button
          w="7rem"
          height="3rem"
          fontSize="2md"
          onClick={handleNext}
          colorScheme="blue"
          variant="outline"
        >
          Next
        </Button>

        <Button
          w="7rem"
          height="3rem"
          fontSize="2md"
          onClick={handleBack}
          colorScheme="blue"
          variant="outline"
        >
          back
        </Button> */}
         <Button
        mt="40px"
        colorScheme="blue"
        onClick={handleNext}
      >
        Submit
      </Button>
      </Box>
    </>
  );
};

export default Form2;
